
define('text!pages/ad_form/copy_ad_modal_template.html',[],function () { return '<p>\r\n  <%- _.t(\'modal.text.copy_ad\') %>\r\n</p>\r\n<p>\r\n  <button class="button js-cancel-button"><%- _.t(\'modal.button.cancel\') %></button>\r\n  <button class="button button-primary js-confirm-button"><%- _.t(\'modal.button.confirm\') %></button>\r\n</p>\r\n';});

